import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const ReviewSummary = styled.div`
  background: ${props => props.theme.palette.primary.alphaLight};
  margin-bottom: 15px;
  padding: 30px;
  text-align: center;

  span {
    display: block;
    margin: 15px 0;
  }

  .react-rater-star {
    width: 20px;
    height: 20px;
    background-size: contain;
    margin: 0 7px 0 0;
  }

  .trustpilot-widget {
    iframe {
      min-height: 30px;
    }
  }
`

export const ReviewsList = styled.div`
  max-width: 600px;
  margin: auto;
  padding: 20px;
`

export const ReviewWrapper = styled.div`
  background: ${props => props.theme.palette.primary.alphaLight};
  margin-bottom: 15px;
  padding: 20px;

  .react-rater-star {
    width: 12px;
    height: 12px;
    background-size: contain;
    margin: 0 5px 0 0;
  }

  .review {
    &__title {
      padding: 0;
      border: none;
      margin-top: 2px;
      text-align: center;
    }

    &__cotent {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      > div {
        flex: 1;
        ${bp('sm')`
          flex: auto;
          width: 100%;
          margin: 10px 0;
        `}
      }
    }

    &__slider {
      p {
        margin: 0 0 2px;
      }

      .slider__label {
        display: flex;
        justify-content: space-between;
      }

      > div:not(.slider__label) {
        background-color: ${props => props.theme.palette.general.strong};
        height: 1px;
        margin: 20px 0;
        position: relative;
        width: 100%;

        &::before,
        &::after {
          content: '';
          display: block;
          width: 1px;
          height: 22px;
          background-color: ${props => props.theme.palette.general.strong};
          position: absolute;
          top: -10px;
          bottom: 0;
        }

        &::before {
          left: 0;
        }

        &::after {
          right: 0;
        }

        > div:first-child {
          display: none;
        }

        > div:last-child {
          div {
            pointer-events: none;
            width: 9px;
            height: 9px;
            background: ${props => props.theme.palette.general.strong};
          }
        }
      }
    }
  }
`

export const NoReviews = styled.h2`
  text-align: center;
`
